
const isStrEmpty = function (value: any) {
  const valueStr = String(value);
  return valueStr === 'null' || valueStr === 'undefined' || valueStr.length === 0
};

const isEmojiCharacter = (value: any) => {
  if (isStrEmpty(value)) {
    return false;
  }

  return (value >= 0x2600 && value <= 0x27BF) // 杂项符号与符号字体
  || value == 0x303D
  || value == 0x2049
  || value == 0x203C
  || (value >= 0x2000 && value <= 0x200F)//
  || (value >= 0x2028 && value <= 0x202F)//
  || value == 0x205F //
  || (value >= 0x2065 && value <= 0x206F)//
  /* 标点符号占用区域 */
  || (value >= 0x2100 && value <= 0x214F)// 字母符号
  || (value >= 0x2300 && value <= 0x23FF)// 各种技术符号
  || (value >= 0x2B00 && value <= 0x2BFF)// 箭头A
  || (value >= 0x2900 && value <= 0x297F)// 箭头B
  || (value >= 0x3200 && value <= 0x32FF)// 中文符号
  || (value >= 0xD800 && value <= 0xDFFF)// 高低位替代符保留区域
  || (value >= 0xE000 && value <= 0xF8FF)// 私有保留区域
  || (value >= 0xFE00 && value <= 0xFE0F)// 变异选择器
  || value >= 0x10000; // Plane在第二平面以上的，char都不可以存，全部都转
}

const validSpecialCharacter = (value: string) => {
  if (isStrEmpty(value)) {
      return false;
  }
  for (let index = 0; index < value.length; index++) {
    const charCode = value.charCodeAt(index);
    // emoji表情判断
    if (isEmojiCharacter(charCode)) {
        return true;
    }
  }
  return false;
}

export default validSpecialCharacter